export enum Configurator {
  CarportView = 'carport-view',
  ShedView = 'shed-view',
}
